<template>
    <b-form-select
        v-model="form.fiscal_year"
        :class="reactiveClass"
        size="sm"
        :options="fiscalYearOptions"
        @change="saveFiscalYear"
    />
</template>

<script>
import TableFormHandler from '../../../common/mixins/TableFormHandler'

export default {
    name: 'FiscalYearForm',

    mixins: [TableFormHandler],

    props: {
        entry: {},
    },

    data() {
        return {
            form: {},
            fiscalYearOptions: [],
        }
    },

    async created() {
        this.initFiscalYear()
        this.form.fiscal_year = this.entry.fiscal_year
    },

    methods: {
        initFiscalYear() {
            const actualYear = new Date().getFullYear()
            const previousYear = actualYear - 1
            const nextYear = actualYear + 1
            this.fiscalYearOptions.push({
                value: actualYear,
                text: actualYear.toString(),
            })
            this.fiscalYearOptions.push({
                value: previousYear,
                text: previousYear.toString(),
            })
            this.fiscalYearOptions.push({
                value: nextYear,
                text: nextYear.toString(),
            })
        },

        async saveFiscalYear() {
            this.form.activity_date = this.entry.activity_date
            try {
                await axios.put(
                    `/time-sheets/${this.entry.id}/fiscal-year`,
                    this.form
                )
                this.handleSelectSuccess()
                // this.$root.$refs.timeSheetsInput.getData()
            } catch (error) {
                console.log(error)
                this.handleError()
                if (error.response) {
                    if (error.response.status === 403) {
                        this.$store.commit(
                            'timeSheetsVM/SET_ERROR',
                            error.response.data.meta.message
                        )
                    }
                }
            }
        },
    },
}
</script>

<style scoped></style>
